import {
  APP_POSTHOG_CLIENT_KEY as _APP_POSTHOG_CLIENT_KEY,
  APP_POSTHOG_PROXY_ENDPOINT as _APP_POSTHOG_PROXY_ENDPOINT,
  BLENDED_SERVICE_ENDPOINT as _BLENDED_SERVICE_ENDPOINT,
  ENVIRONMENT as _ENVIRONMENT,
  LARAVEL_INSTALLABLES_ENDPOINT as _LARAVEL_INSTALLABLES_ENDPOINT,
  PLATFORM_ENDPOINT as _PLATFORM_ENDPOINT,
  VESTABOARD_API_ENDPOINT as _VESTABOARD_API_ENDPOINT,
} from "./secrets";

function graphqlEndpoint(base: string | undefined): string {
  if (!base) return "";
  const trimmed = base.replace(/\/$/, "");
  return trimmed.endsWith("/graphql") ? trimmed : `${trimmed}/graphql`;
}

export const ENVIRONMENT = _ENVIRONMENT ?? "";
export const API_ENDPOINT = _BLENDED_SERVICE_ENDPOINT ?? "";
export const GRAPHQL_ENDPOINT = graphqlEndpoint(_VESTABOARD_API_ENDPOINT);
export const PLATFORM_ENDPOINT = _PLATFORM_ENDPOINT ?? "";
export const EXTERNAL_INSTALLABLE_API_URL =
  _LARAVEL_INSTALLABLES_ENDPOINT ?? "";
export const POSTHOG_CLIENT_KEY = _APP_POSTHOG_CLIENT_KEY ?? "";
export const POSTHOG_PROXY_ENDPOINT = _APP_POSTHOG_PROXY_ENDPOINT ?? "";
